export interface ComparisonPrivateDetail {
  kind: 'thinking'
  value: string
}

export interface ComparisonPrivateDetailPresentation {
  icon: '💭'
  kind: 'thinking'
  labelKey: 'play.comparison.thinkingProcess'
  value: string
}

export function getComparisonPrivateDetailPresentation(
  detail: ComparisonPrivateDetail | null | undefined,
): ComparisonPrivateDetailPresentation | null {
  const value = detail?.value.trim() ?? ''
  if (detail?.kind !== 'thinking' || !value)
    return null

  return {
    icon: '💭',
    kind: 'thinking',
    labelKey: 'play.comparison.thinkingProcess',
    value,
  }
}
